import { useState, useMemo, useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { ModalRef } from "@shared/components";
import { Category } from "@modules/categorys/types";

export function useCategoryList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const createCategoryModalRef = useRef<ModalRef>(null);
  const editCategoryModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<Category>({
    resource: "v1/category_admin",
    filters: getQueryParams(),
    sorters: {  ordering: "-id" }
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    createCategoryModalRef,
    editCategoryModalRef,
    refetch,
    setSelectedRows,
    translate,

  };
}
